// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeLog_wrapper__bOd96","form":"ChangeLog_form__U54zF","emailWrapper":"ChangeLog_emailWrapper__EunPw","itemWrapper":"ChangeLog_itemWrapper__86dJH"};